import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            markAsReadUrl: String,
            markAsUnreadUrl: String
        }
    }

    static get targets() {
        return ["unreadIndicator", "markAllAsRead", "userNotification"];
    }

    async markAsReadFromExternalSource(userNotificationId) {
        await this.markAsRequest(userNotificationId, true);
        const markAsElement = this.element.querySelector(`[data-user-notification-id="${userNotificationId}"] .l-header__notifications-dropdown-item-mark-as`);

        if (markAsElement) {
            markAsElement.title = markAsElement.dataset.markAsUnreadTitle;
            markAsElement.classList.remove("l-header__notifications-dropdown-item-mark-as--read");
            this.refreshGroupIndicators();
        }
    }

    async markAllAsRead(e) {
        e.preventDefault();

        for (const userNotificationTarget of this.userNotificationTargets) {
            const markAsElement = userNotificationTarget.querySelector(".l-header__notifications-dropdown-item-mark-as");

            if (markAsElement.classList.contains("l-header__notifications-dropdown-item-mark-as--read")) {
                await this.markAsRequest(userNotificationTarget.dataset.userNotificationId, true);
                markAsElement.title = markAsElement.dataset.markAsUnreadTitle;
                markAsElement.classList.remove("l-header__notifications-dropdown-item-mark-as--read");
            }
        }

        this.refreshGroupIndicators();
    }

    markAsReadWithoutRequest(e) {
        e.target.closest("[data-user-notification-id]").querySelector(".l-header__notifications-dropdown-item-mark-as")?.classList.remove("l-header__notifications-dropdown-item-mark-as--read");
        this.refreshGroupIndicators();
    }

    async markAs(e) {
        e.preventDefault();
        const userNotificationTarget = e.target.closest("[data-user-notification-id]");
        const markAsElement = userNotificationTarget.querySelector(".l-header__notifications-dropdown-item-mark-as");
        const markAsRead = markAsElement.classList.contains("l-header__notifications-dropdown-item-mark-as--read");
        await this.markAsRequest(userNotificationTarget.dataset.userNotificationId, markAsRead);
        markAsElement.title = markAsRead ? markAsElement.dataset.markAsUnreadTitle : markAsElement.dataset.markAsReadTitle;
        markAsElement.classList.toggle("l-header__notifications-dropdown-item-mark-as--read", !markAsRead);
        this.refreshGroupIndicators();
    }

    async markAsRequest(userNotificationId, read) {
        const queryParams = new URLSearchParams({ id: userNotificationId });
        await fetch(`${read ? this.markAsReadUrlValue : this.markAsUnreadUrlValue}?${queryParams}`, { method: "post" });
    }

    refreshGroupIndicators() {
        const allRead = this.userNotificationTargets.filter(unt => unt.querySelector(".l-header__notifications-dropdown-item-mark-as--read")).length === 0;
        this.markAllAsReadTarget.classList.toggle("d-none", allRead);
        this.unreadIndicatorTarget.classList.toggle("d-none", allRead);
    }
}